import React, { useState } from 'react';
import Caret from '../../Caret';

import {
  StyledDropdown,
  StyledDropdownProps,
  StyledDropdownToggle,
  StyledDropdownItem,
  StyledDropdownMenu,
} from './styled';

export type DropdownProps<TValue extends string> = StyledDropdownProps & {
  fluid?: boolean;
  placeholder?: string;
  value?: TValue;
  isInvalid?: boolean;
  options: Array<{
    value: TValue;
    label: string;
  }>;
  onOptionSelect: (value: TValue) => void;
};

const Dropdown = <TValue extends string>({
  fluid = false,
  placeholder = '',
  value,
  isInvalid = false,
  options,
  onOptionSelect,
  className,
}: DropdownProps<TValue>) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <StyledDropdown
      className={`ghc-form-dropdown ${className ?? ''}`}
      toggle={() => setIsOpen(!isOpen)}
      isOpen={isOpen}
    >
      <StyledDropdownToggle
        fluid={fluid}
        showPlaceholder={!!value}
        className={isInvalid ? 'is-invalid' : ''}
        data-testid="dropdown-toggle"
      >
        <span>
          {value
            ? options.find((option) => option.value === value)?.label
            : placeholder}
        </span>
        <Caret facing="down" />
      </StyledDropdownToggle>
      {isOpen && (
        <StyledDropdownMenu fluid={fluid}>
          {options.map((option) => (
            <StyledDropdownItem
              key={option.value}
              selected={value === option.value}
              onClick={() => {
                onOptionSelect(option.value);
              }}
            >
              {option.label}
            </StyledDropdownItem>
          ))}
        </StyledDropdownMenu>
      )}
    </StyledDropdown>
  );
};

export default Dropdown;
